<div class="counter-loader"></div>
<div class="counter">{{ count }}</div>
